/* eslint-disable max-len */
import {
  conditionType,
  inputType
} from '../../../../../pages/esgManager/interface/inputType';
import {
  createRowDatePickerField,
  createRowMultiSelectField,
  createRowNumberField,
  createRowSelectField,
  createRowWysiwygField,
  createSelectField,
  createTableQuestion,
  createTableWithFixedRowsQuestion
} from '../../../Utils/questionHelper';
import {COUNTRY_OPTIONS} from '../SME/smeQuestions';

import {
  CDP_SUPPLY_CHAIN_LINKAGE_OPTIONS,
  CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS,
  CHEMICAL_PRODUCTS_OPTIONS,
  COVERAGE_PERCENTAGE_OPTIONS,
  DATA_AVAILABILITY_OPTIONS,
  ELECTRICITY_GENERATION_INTENSITY_UNIT_OPTIONS,
  EXCLUSION_OPTIONS,
  FACILITY_OPTIONS,
  FIVE_YEAR_FORECAST_OPTIONS,
  FREQUENCY_OF_MEASUREMENT_OPTIONS,
  HAZARDOUS_SUBSTANCE_REGULATORY_LISTS_OPTIONS,
  HIGHEST_LEVEL_OF_TREATMENT_OPTIONS,
  HYDROPOWER_ENVIRONMENTAL_FLOW_ASPECTS_OPTIONS,
  IDENTIFICATION_TOOL_OPTIONS,
  METALS_MINING_INTENSITY_UNIT_OPTIONS,
  OIL_AND_GAS_BUSINESS_DIVISION_OPTIONS,
  OIL_GAS_BUSINESS_DIVISION_OPTIONS,
  OIL_GAS_INTENSITY_UNIT_OPTIONS,
  PERCENTAGE_COVERAGE_ZERO_START_OPTIONS,
  PERCENTAGE_RANGE_OPTIONS,
  PERCENTAGE_SIMPLE_RANGE_OPTIONS,
  PERCENTAGE_WITH_NOT_MONITORED_OPTIONS,
  POWER_GENERATION_TECHNOLOGY_OPTIONS,
  PRIMARY_REASON_FOR_COMPARISON_OPTIONS,
  PRIMARY_REASON_OPTIONS,
  PRIORITY_SUBSTANCES_DISCHARGED_OPTIONS,
  REASON_FOR_EXCLUSION_OPTIONS,
  REASON_FOR_NO_TARGET_OPTIONS,
  REASON_FOR_NO_WATER_TARGET_OPTIONS,
  RELEVANCE_OPTIONS,
  REVENUE_FROM_LOW_WATER_IMPACT_PRODUCTS_OPTIONS,
  TARGET_50_OPTIONS,
  TARGET_LEVEL_OPTIONS,
  TARGET_STATUS_IN_REPORTING_YEAR_OPTIONS,
  VALUE_CHAIN_ASSESSMENT_STATUS_OPTIONS,
  VALUE_CHAIN_STAGE_OPTIONS,
  VERIFICATION_COVERAGE_OPTIONS,
  WATER_ACCOUNTING_BY_BUSINESS_DIVISION_OPTIONS,
  WATER_ACCOUNTING_DATA_COLLECTED_OPTIONS,
  WATER_ASPECT_OPTIONS,
  WATER_ASPECTS_MONITORED_OPTIONS,
  WATER_DISCHARGE_DESTINATION_OPTIONS,
  WATER_INTENSITY_CALCULATION_OPTIONS,
  WATER_INTENSITY_METRIC_OPTIONS,
  WATER_INTENSITY_UNIT_OPTIONS,
  WATER_RELATED_ASPECTS_OPTIONS,
  WATER_SOURCE_TYPE_OPTIONS,
  WATER_TARGET_ALIGNMENT_FRAMEWORKS_OPTIONS,
  WATER_TARGET_CATEGORY_OPTIONS,
  WATER_TARGET_TYPE_OPTIONS,
  WEIGHT_VOLUME_UNIT_OPTIONS,
  WITHDRAWALS_AND_DISCHARGES_OPTIONS,
  YES_NO_OPTIONS,
  YES_NO_UNKNOWN_ONLY_OPTIONS,
  YES_NO_WITH_PLAN_OPTIONS
} from './corporateOptions';
import {CDP_WATER_SECURITY_KEYS} from './corporateQuestionsKeys';

export const environmentalPerformanceWaterSecurityQuestions = [
  {
    key: 'Q1',
    showIndex: false,
    items: [
      {
        field: [
          {
            ...createSelectField(
              CDP_WATER_SECURITY_KEYS.Q1_VALUE,
              '9.1 Are there any exclusions from your disclosure of water-related data?',
              YES_NO_OPTIONS,
              inputType.HEADING
            ),
            tooltip:
              'CDP seeks to share comprehensive and representative water data. If organizations do need to exclude areas of their business from their disclosure, data users must be informed of the exclusions as this may affect their analysis.',
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: 'Q2',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q2_VALUE,
        '9.1.1 Provide details on these exclusions.',
        'An organization’s disclosure must be comprehensive and representative to ensure data user confidence in the information reported. As such, organizations are encouraged to report on any exclusions to their disclosure including any geographies, facilities, and other water aspects Ambition The organization reports on all exclusions from the reporting boundary and does not have any significant exclusions from their disclosure.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q2_1_VALUE,
            'Exclusion',
            EXCLUSION_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q2_2_VALUE,
            'Description of exclusion',
            1500
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q2_3_VALUE,
            'Reason for exclusion',
            REASON_FOR_EXCLUSION_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q2_4_VALUE,
            'Primary reason why data is not available',
            PRIMARY_REASON_OPTIONS
          ),
          createRowDatePickerField(
            CDP_WATER_SECURITY_KEYS.Q2_5_VALUE,
            'Completion date of acquisition or merger'
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q2_6_VALUE,
            'Data from the merger/acquisition will be incorporated in the next reporting year',
            YES_NO_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q2_7_VALUE,
            'Percentage of water volume the exclusion represents',
            PERCENTAGE_RANGE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q2_8_VALUE,
            'Please explain',
            1500
          )
        ],
        true,

        undefined,
        CDP_WATER_SECURITY_KEYS.Q1_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q3',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q3_VALUE,
        '9.2 Across all your operations, what proportion of the following water aspects are regularly measured and monitored?',
        'This question allows your company to indicate to investors, customers, and other data users the extent to which it monitors different aspects of its water use. Comprehensive water accounting is a first step in understanding the importance of water to your business and any potential water-related impacts to your business. This data may also be relevant to a company’s regulatory compliance.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q3_1_VALUE,
            'Water aspect',
            WATER_ASPECTS_MONITORED_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q3_2_VALUE,
            '% of sites/facilities/operations',
            COVERAGE_PERCENTAGE_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q3_3_VALUE,
            'Frequency of measurement',
            FREQUENCY_OF_MEASUREMENT_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q3_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Not monitored', 'Not relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q3_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Not monitored', 'Not relevant'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q3_4_VALUE,
            'Method of measurement',
            500,
            undefined,
            undefined,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q3_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Not monitored', 'Not relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q3_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Not monitored', 'Not relevant'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q3_5_VALUE,
            'Please explain',
            1000
          )
        ]
      )
    ]
  },
  {
    key: 'Q4',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q4_VALUE,
        '9.2.1 For your hydropower operations, what proportion of the following water aspects are regularly',
        'Dam operation implies an alteration of the natural river flow and sediment movement. Changes to river hydrology may affect instream and streamside habitats and affect local biodiversity. Ensuring appropriate environmental flows and sediment loadings helps to maintain water ecosystems and their basic functions. Sediments can collect behind a dam because the dam itself is a physical barrier. Eventually they can reduce the operative capacity of dams. When sediments collect, ecosystems upstream and downstream can be affected. CDP acknowledges that there is no universally accepted methodology for establishing environmental flows. In their simplest form, they can include low- and high- water regimes, and in their most complex, they may consider biodiversity and socioeconomic factors. Environmental flows may be established in national, regional or local legislation and there may be a legal requirement for hydropower operations to maintain those flows. In many countries/areas, however, they are not legally established and organizations looking to maintain environmental flows would need to rely on available literature or data. This question allows organizations to demonstrate their leadership in evaluating the environmental impacts of their operations, especially where legal and regulatory frameworks in this area are weak.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q4_1_VALUE,
            'Water aspect',
            HYDROPOWER_ENVIRONMENTAL_FLOW_ASPECTS_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q4_2_VALUE,
            '% of sites/facilities/operations measured and monitored',
            COVERAGE_PERCENTAGE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q4_3_VALUE,
            'Please explain',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q5',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_WATER_SECURITY_KEYS.Q5_VALUE,
        '9.2.2 What are the total volumes of water withdrawn, discharged, and consumed across all your operations, how do they compare to the previous reporting year, and how are they forecasted to change?',
        'This question incentivizes companies to have a complete view of their water balance at the corporate level and to assess anticipated forward trends in water demand, encouraging a transition towards business models which do not pose threats to rivers, lakes, aquifers, and streams. Total volumes can indicate the organization’s relative significance as a user of water and provide a baseline figure for other calculations. Along with trend data, these volumes can also suggest the level of risk posed by future disruptions to water supplies or increases in the cost of water. Water consumption measures water that is no longer available for use by the ecosystem or local community in the reporting period. Reporting the volume of water consumption contributes to an organization’s understanding of the overall scale of its impact due to water withdrawal on downstream water availability. Water aspect',
        'Water aspect',
        [
          {id: 'Total withdrawals', label: 'Total withdrawals'},
          {id: 'Total discharges', label: 'Total discharges'},
          {id: 'Total consumption', label: 'Total consumption'}
        ],
        [
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q5_1_VALUE,
            'Volume (megaliters/year)',
            2
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q5_2_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q5_3_VALUE,
            'Primary reason for comparison with previous reporting year',
            PRIMARY_REASON_FOR_COMPARISON_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q5_4_VALUE,
            'Five-year forecast',
            FIVE_YEAR_FORECAST_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q5_5_VALUE,
            'Primary reason for forecast',
            PRIMARY_REASON_FOR_COMPARISON_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q5_6_VALUE,
            'Please explain',
            2000
          )
        ]
      )
    ]
  },
  {
    key: 'Q6',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q6_VALUE,
        '9.2.3 In your oil & gas sector operations, what are the total volumes of water withdrawn, discharged, and consumed (by business division), how do they compare to the previous reporting year, and how are they forecasted to change?',
        'This question incentivize companies to have a complete view of their water balance at the business division level and to assess anticipated forward trends in water demand, encouraging a transition towards business models which do not pose threats to rivers, lakes, aquifers, and streams. Volumes of water withdrawals, discharges, and consumption typically differ significantly between business divisions. Detailing the water balance at this scale provides data users with an understanding of the key phases that determine the organization’s water balance and allow a better interpretation of answers provided in other sections of the questionnaire.',

        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q6_1_VALUE,
            'Water aspect by business division',
            WATER_ACCOUNTING_BY_BUSINESS_DIVISION_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q6_2_VALUE,
            'Volume (megaliters/year)',
            2
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q6_3_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q6_4_VALUE,
            'Primary reason for comparison with previous reporting year',
            PRIMARY_REASON_FOR_COMPARISON_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q6_5_VALUE,
            'Five-year forecast',
            FIVE_YEAR_FORECAST_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q6_6_VALUE,
            'Primary reason for forecast',
            PRIMARY_REASON_FOR_COMPARISON_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q6_7_VALUE,
            'Please explain',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q7',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q7_VALUE,
        '9.2.4 Indicate whether water is withdrawn from areas with water stress, provide the volume, how it compares with the previous reporting year, and how it is forecasted to change.',
        'Since water is a shared resource, and water-related impacts are localized, organizations are increasingly encouraged to prioritize action in areas with water stress and to understand and respond to local contexts. This question on water from stressed areas supports a trend towards metrics for corporate water reporting and target setting informed by local context, and in addition, the TCFD recommends disclosure of reliance on water from areas of water stress. This question also incentivizes organizations to assess anticipated forward trends in withdrawals from water stressed areas, encouraging a transition towards business models which do not pose threats to rivers, lakes, aquifers, and streams. The data requested assists the assessment of your organization’s dependence on potentially contested sources (regardless of whether your facility itself is located in a stressed area), as well as your potential impact on sensitive locations. Water stress is a driver of business risk and, as stress is likely to worsen, transparency is critical. Understanding elevated business risk due to operations in water stressed areas is important for the investor community, and this question allows data users to review the trend in dependency on water from stressed basins. Knowledge of water-related hot spots helps your organization identify where water stress may be affecting its operations, now or in the future, as well as to prioritize your sustainable water management practices.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
            'Withdrawals are from areas with water stress',
            YES_NO_UNKNOWN_ONLY_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q7_2_VALUE,
            'Volume withdrawn from areas with water stress (megaliters)',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.NOT,
              values: ['No', 'Unknown']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.EQUALS,
              values: ['No', 'Unknown'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q7_3_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.NOT,
              values: ['No', 'Unknown']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.EQUALS,
              values: ['No', 'Unknown'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q7_4_VALUE,
            'Primary reason for comparison with previous reporting year',
            PRIMARY_REASON_FOR_COMPARISON_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.NOT,
              values: ['No', 'Unknown']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.EQUALS,
              values: ['No', 'Unknown'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q7_5_VALUE,
            'Five-year forecast',
            FIVE_YEAR_FORECAST_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.NOT,
              values: ['No', 'Unknown']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.EQUALS,
              values: ['No', 'Unknown'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q7_6_VALUE,
            'Primary reason for forecast',
            PRIMARY_REASON_FOR_COMPARISON_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.NOT,
              values: ['No', 'Unknown']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.EQUALS,
              values: ['No', 'Unknown'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q7_7_VALUE,
            '% of total withdrawals that are withdrawn from areas with water stress',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.NOT,
              values: ['No', 'Unknown']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.EQUALS,
              values: ['No', 'Unknown'],
              required: true
            }
          ),
          createRowMultiSelectField(
            CDP_WATER_SECURITY_KEYS.Q7_8_VALUE,
            'Identification tool',
            IDENTIFICATION_TOOL_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.NOT,
              values: ['Unknown']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q7_1_VALUE,
              condition: conditionType.EQUALS,
              values: ['Unknown'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q7_9_VALUE,
            'Please explain',
            5000
          )
        ]
      )
    ]
  },
  {
    key: 'Q8',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_WATER_SECURITY_KEYS.Q8_VALUE,
        '9.2.5 What proportion of the produced agricultural commodities that are significant to your organization originate from areas with water stress?',
        'This question provides data users with information on the exposure that the organization may have to scarce resources in their direct operations. This metric will also allow data users to better understand the answers provided in other sections of the questionnaire.',
        'Agricultural commodities',
        [],
        [
          // createRowMultiSelectField(
          //   CDP_WATER_SECURITY_KEYS.Q8_1_VALUE,
          //   'Agricultural commodities',
          //   COMMODITY_OPTIONS
          // ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q8_2_VALUE,
            'The proportion of this commodity sourced from areas with water stress is known',
            DATA_AVAILABILITY_OPTIONS,
            true
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q8_3_VALUE,
            '% of total agricultural commodity sourced from areas with water stress',
            PERCENTAGE_COVERAGE_ZERO_START_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q8_4_VALUE,
            'Please explain',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q9',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_WATER_SECURITY_KEYS.Q9_VALUE,
        '9.2.6 What proportion of the sourced agricultural commodities that are significant to your organization',
        'This question provides data users with information on an organization’s exposure to scarce resources in their value chain. This metric will also allow data users to better understand the answers provided in other sections of the questionnaire.',
        'Agricultural commodities',
        [],
        [
          // createRowMultiSelectField(
          //   CDP_WATER_SECURITY_KEYS.Q9_1_VALUE,
          //   'Agricultural commodities',
          //   COMMODITY_OPTIONS
          // ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q9_2_VALUE,
            'The proportion of this commodity sourced from areas with water stress is known',
            DATA_AVAILABILITY_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q9_3_VALUE,
            '% of total agricultural commodity sourced from areas with water stress',
            PERCENTAGE_COVERAGE_ZERO_START_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q9_4_VALUE,
            'Please explain',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q10',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q10_VALUE,
        '9.2.7 Provide total water withdrawal data by source.',
        'This question only appears if you indicate in 9.2 that you monitor the following water aspect(s): Water withdrawals – volume by source No change',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q10_1_VALUE,
            'Source',
            WATER_SOURCE_TYPE_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q10_2_VALUE,
            'Relevance',
            RELEVANCE_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q10_3_VALUE,
            'Volume (megaliters/year)',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q10_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q10_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q10_4_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q10_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q10_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q10_5_VALUE,
            'Primary reason for comparison with previous reporting year',
            PRIMARY_REASON_FOR_COMPARISON_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q10_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q10_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q10_6_VALUE,
            'Please explain',
            1000,
            undefined,
            undefined,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q10_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant but volume unknown', 'Not relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q10_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant but volume unknown', 'Not relevant'],
              required: true
            }
          )
        ],
        false,

        CDP_WATER_SECURITY_KEYS.Q3_VALUE,
        CDP_WATER_SECURITY_KEYS.Q3_1_VALUE,
        ['Water withdrawals - volumes by source']
      )
    ]
  },
  {
    key: 'Q11',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q11_VALUE,
        '9.2.8 Provide total water discharge data by destination.',
        'Reporting volume of water discharged to specific destinations contributes to an understanding of the specific risks and impacts associated with an organization’s water discharges.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q11_1_VALUE,
            'Destination',
            WATER_DISCHARGE_DESTINATION_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q11_2_VALUE,
            'Relevance',
            RELEVANCE_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q11_3_VALUE,
            'Volume (megaliters/year)',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q11_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q11_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q11_4_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q11_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q11_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q11_5_VALUE,
            'Primary reason for comparison with previous reporting year',
            PRIMARY_REASON_FOR_COMPARISON_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q11_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q11_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q11_6_VALUE,
            'Please explain',
            1000,
            undefined,
            undefined,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q11_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant but volume unknown', 'Not relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q11_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant but volume unknown', 'Not relevant'],
              required: true
            }
          )
        ],
        false,

        CDP_WATER_SECURITY_KEYS.Q3_VALUE,
        CDP_WATER_SECURITY_KEYS.Q3_1_VALUE,
        ['Water discharges - volumes by destination']
      )
    ]
  },
  {
    key: 'Q12',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q12_VALUE,
        '9.2.9 Within your direct operations, indicate the highest level(s) to which you treat your discharge.',
        'Reporting on levels of treatment demonstrates that the organization is monitoring its discharges and is able to understand the extent to which its activities impact water quality. Pollution is a driver of business risk and a potential threat to public health, food security, and economic resilience – as well as a cause of degradation of freshwater biodiversity. Treatment of discharge is therefore critical and transparency on this will aid investors, customers, and other data users to assess the risks and opportunities.',
        [
          createRowMultiSelectField(
            CDP_WATER_SECURITY_KEYS.Q12_1_VALUE,
            'Highest level of treatment within direct operations',
            HIGHEST_LEVEL_OF_TREATMENT_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
            'Relevance of treatment level to discharge',
            RELEVANCE_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q12_3_VALUE,
            'Volume (megaliters/year)',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q12_4_VALUE,
            'Comparison of treated volume with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q12_5_VALUE,
            'Primary reason for comparison with previous reporting year',
            PRIMARY_REASON_FOR_COMPARISON_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q12_6_VALUE,
            '% of your sites/facilities/operations this volume applies to',
            PERCENTAGE_WITH_NOT_MONITORED_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q12_7_VALUE,
            'Please explain',
            2000,
            undefined,
            undefined,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
              condition: conditionType.NOT,
              values: ['Relevant but volume unknown', 'Not relevant']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q12_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Relevant but volume unknown', 'Not relevant'],
              required: true
            }
          )
        ],
        false,

        CDP_WATER_SECURITY_KEYS.Q3_VALUE,
        CDP_WATER_SECURITY_KEYS.Q3_1_VALUE,
        ['Water discharges - volumes by treatment method']
      )
    ]
  },
  {
    key: 'Q13',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q13_VALUE,
        '9.2.10 Provide details of your organization’s emissions of nitrates, phosphates, pesticides, and other priority substances to water in the reporting year.',
        'This question only appears if you select any response other than “Not monitored” or “Not relevant” in column “% of sites/facilities/operations” for the row “Water discharge quality – emissions to water (nitrates, phosphates, pesticides, and/or other priority substances)” of 9.2. No change This question allows organizations to indicate their emissions to water of priority substances, helping them understand, manage, and reduce the use of nitrates, phosphates, pesticides, and other priority substances.',
        [
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q13_1_VALUE,
            'Emissions to water in the reporting year (metric tons)',
            2
          ),
          createRowMultiSelectField(
            CDP_WATER_SECURITY_KEYS.Q13_2_VALUE,
            'Categories of substances included',
            PRIORITY_SUBSTANCES_DISCHARGED_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q13_3_VALUE,
            'List the specific substances included',
            1000,
            undefined,
            undefined,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q13_2_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: [
                'Priority substances listed under the EU Water Framework Directive'
              ]
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q13_2_VALUE,
              condition: conditionType.INCLUDES,
              values: [
                'Priority substances listed under the EU Water Framework Directive'
              ],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q13_4_VALUE,
            'Please explain',
            1500
          )
        ],
        false,
        CDP_WATER_SECURITY_KEYS.Q3_VALUE,
        CDP_WATER_SECURITY_KEYS.Q3_2_VALUE,
        ['Less than 1%', '1-25%', '26-50%', '51-75%', '76-99%', '100%']
      )
    ]
  },
  {
    key: 'Q14',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q14_VALUE,
        '9.3 In your direct operations and upstream value chain, what is the number of facilities where you have identified substantive water-related dependencies, impacts, risks, and opportunities?',
        'Water is a local issue, and data users want to know that organizations are considering dependencies, impacts, risks, and opportunities at the facility level. Reporting the total count of facilities where substantive water-related dependencies, impacts, risks, and/or opportunities have been identified provides a basic but useful indication of the organization’s reliance on these areas. Reporting the proportion of total facilities in your direct operations that have been identified allows data users to understand the importance of these facilities relative to the size of your organization.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q14_1_VALUE,
            'Value chain stage',
            VALUE_CHAIN_STAGE_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q14_2_VALUE,
            'Identification of facilities in the value chain stage',
            VALUE_CHAIN_ASSESSMENT_STATUS_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q14_3_VALUE,
            'Total number of facilities identified'
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q14_4_VALUE,
            '% facilities in direct operations that this represents',
            PERCENTAGE_SIMPLE_RANGE_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q14_2_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, we have assessed this value chain stage and identified facilities with water-related dependencies, impacts, risks, and opportunities'
              ]
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q14_2_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, we have assessed this value chain stage and identified facilities with water-related dependencies, impacts, risks, and opportunities'
              ],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q14_5_VALUE,
            'Please explain',
            2000
          )
        ]
      )
    ]
  },
  {
    key: 'Q15',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q15_VALUE,
        '9.3.1 For each facility referenced in 9.3, provide coordinates, water accounting data, and a comparison with the previous reporting year.',
        `Reporting information on facilities where you have identified substantive water-related dependencies, impacts, risks, and/or opportunities helps data users have confidence that your organization is monitoring local water aspects. It provides insight to dependency on different sources and potential impacts associated with water withdrawals and discharges. For example, withdrawing from an overdrawn freshwater aquifer rather than from seawater will have significantly different consequences for local areas with water stress and an organization's water security. In regions where water sources are highly restricted, the organization's water consumption patterns can influence relations with other stakeholders. Providing facility-level information is useful for demonstrating regulatory compliance (e.g., discharges to the local environment), for risk assessments and for providing insight to risk responses (e.g., tracking water efficiency improvements). Geo-location coordinates for your facilities with substantive water-related dependencies, impacts, risks, and/or opportunities enables data users to analyze geographically linked dependencies, impacts, risks, and opportunities and to do so across multiple companies. This also facilitates the integration of CDP${'’'}s water data with other geographically linked data`,
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_1_VALUE,
            'Facility reference number',
            FACILITY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q15_2_VALUE,
            'Facility name (optional)',
            500
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
            'Value chain stage',
            VALUE_CHAIN_STAGE_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_4_VALUE,
            'Dependencies, impacts, risks, and/or opportunities identified at this facility',
            WATER_RELATED_ASPECTS_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_5_VALUE,
            'Withdrawals or discharges in the reporting year',
            WITHDRAWALS_AND_DISCHARGES_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q15_6_VALUE,
            'Reason for no withdrawals and/or discharges',
            1000,
            undefined,
            undefined,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_5_VALUE,
              condition: conditionType.NOT,
              values: ['Yes, discharges only', 'No']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_5_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes, discharges only', 'No'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_7_VALUE,
            'Country/Area & River basin',
            COUNTRY_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_8_VALUE,
            'Latitude',
            6,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_9_VALUE,
            'Longitude',
            6,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_10_VALUE,
            'Located in area with water stress',
            YES_NO_UNKNOWN_ONLY_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_11_VALUE,
            'Primary power generation source for your electricity generation at this facility',
            POWER_GENERATION_TECHNOLOGY_OPTIONS
          ),
          createRowMultiSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_12_VALUE,
            'Oil & gas sector business division',
            OIL_AND_GAS_BUSINESS_DIVISION_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_13_VALUE,
            'Total water withdrawals at this facility (megaliters)',
            2
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_14_VALUE,
            'Comparison of total withdrawals with previous reporting year',
            FIVE_YEAR_FORECAST_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_15_VALUE,
            'Withdrawals from fresh surface water, including rainwater, water from wetlands, rivers, and lakes',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_16_VALUE,
            'Withdrawals from brackish surface water / seawater',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_17_VALUE,
            'Withdrawals from groundwater – renewable',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_18_VALUE,
            'Withdrawals from groundwater – non-renewable',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_19_VALUE,
            'Withdrawals from produced/entrained water',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_20_VALUE,
            'Withdrawals from third party sources',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_21_VALUE,
            'Total water discharges at this facility (megaliters)',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_5_VALUE,
              condition: conditionType.NOT,
              values: [
                'Yes, discharges only',
                'Yes, withdrawals and discharges'
              ]
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_5_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'Yes, discharges only',
                'Yes, withdrawals and discharges'
              ],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_22_VALUE,
            'Comparison of total discharges with previous reporting year',
            FIVE_YEAR_FORECAST_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_23_VALUE,
            'Discharges to fresh surface water',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_24_VALUE,
            'Discharges to brackish surface water/seawater',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_25_VALUE,
            'Discharges to groundwater',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_26_VALUE,
            'Discharges to third party destinations',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.NOT,
              values: ['Direct operations']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q15_3_VALUE,
              condition: conditionType.EQUALS,
              values: ['Direct operations'],
              required: true
            }
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q15_27_VALUE,
            'Total water consumption at this facility (megaliters)',
            2
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q15_28_VALUE,
            'Comparison of total consumption with previous reporting year',
            FIVE_YEAR_FORECAST_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q15_29_VALUE,
            'Please explain',
            1500
          )
        ],
        false,

        CDP_WATER_SECURITY_KEYS.Q14_VALUE,
        CDP_WATER_SECURITY_KEYS.Q14_2_VALUE,
        [
          'Yes, we have assessed this value chain stage and identified facilities with water-related dependencies, impacts, risks, and opportunities'
        ]
      )
    ]
  },
  {
    key: 'Q16',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q16_VALUE,
        '9.3.2 For the facilities in your direct operations referenced in 9.3.1, what proportion of water accounting data has been third party verified?',
        'Providing third party verification for water accounting data at facilities with substantive waterrelated dependencies, impacts, risks, and/or opportunities gives CDP data users increased confidence in the data you are reporting.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q16_1_VALUE,
            'Water aspect',
            WATER_ACCOUNTING_DATA_COLLECTED_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q16_2_VALUE,
            '% verified',
            VERIFICATION_COVERAGE_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q16_3_VALUE,
            'Verification standard used',
            1500
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q16_4_VALUE,
            'Please explain',
            2500
          )
        ],
        false,

        CDP_WATER_SECURITY_KEYS.Q14_VALUE,
        CDP_WATER_SECURITY_KEYS.Q14_2_VALUE,
        [
          'Yes, we have assessed this value chain stage and identified facilities with water-related dependencies, impacts, risks, and opportunities'
        ]
      )
    ]
  },
  {
    key: 'Q17',
    showIndex: false,
    items: [
      {
        field: [
          {
            ...createSelectField(
              CDP_WATER_SECURITY_KEYS.Q17_VALUE,
              '9.4 Could any of your facilities reported in 9.3.1 have an impact on a requesting CDP supply chain member?',
              CDP_SUPPLY_CHAIN_LINKAGE_OPTIONS,
              inputType.HEADING
            ),
            tooltip:
              'In 9.3 you were asked to identify the number of your facilities with substantive waterrelated dependencies, impacts, risks, and/or opportunities. In 9.3.1 you then reported water accounting data for these facilities. This question asks whether any of these facilities could have an impact on a requesting CDP supply chain member.',
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: 'Q18',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q18_VALUE,
        '9.4.1 Indicate which of the facilities referenced in 9.3.1 could impact a requesting CDP supply chain',
        'Indicating which of your customers use goods or services produced by facilities referenced in 9.3.1 will help them understand and take action to respond to their substantive water-related dependencies, impacts, risks and/or opportunities.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q18_1_VALUE,
            'Facility reference number',
            FACILITY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q18_2_VALUE,
            'Facility name',
            500
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q18_3_VALUE,
            'Requesting member'
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q18_4_VALUE,
            'Description of potential impact on member',
            1000
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q18_5_VALUE,
            'Comment',
            1000
          )
        ],
        true,

        undefined,
        CDP_WATER_SECURITY_KEYS.Q17_VALUE,
        [
          'Yes, CDP supply chain members buy goods or services from facilities listed in 9.3.1'
        ]
      )
    ]
  },
  {
    key: 'Q19',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q19_VALUE,
        '9.5 Provide a figure for your organization’s total water withdrawal efficiency.',
        'A water withdrawal efficiency metric enables organizations to track the water-dependency of their revenue, as well as bench mark their water use. Awareness of water efficiency can drive cost savings, increased brand value, and product or service innovation. This metric helps data users track an organization’s transition towards a water secure future.',
        [
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q19_1_VALUE,
            'Revenue (currency)',
            2
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q19_2_VALUE,
            'Total water withdrawal efficiency'
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q19_3_VALUE,
            'Anticipated forward trend',
            500
          )
        ]
      )
    ]
  },
  {
    key: 'Q20',
    showIndex: false,
    items: [
      {
        field: [
          {
            ...createSelectField(
              CDP_WATER_SECURITY_KEYS.Q20_VALUE,
              '9.6 Do you calculate water intensity for your activities in the chemical sector?',
              YES_NO_WITH_PLAN_OPTIONS,
              inputType.HEADING
            ),
            tooltip:
              'This metric encourages organizations with activities in the chemical sector to monitor water intensity data and improve efficiency. In addition to total water volumes, water intensity metrics provide a complementary indicator to help identify efficiencies and opportunities for the reduction in water withdrawals or consumption. Data users seek improved transparency around the calculation of such metrics to enable performance monitoring and high-level benchmarking. This question aligns with public policy goals related to water at all levels, such as the Sustainable Development Goal 6.4.1.',
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: 'Q21',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q21_VALUE,
        '9.6.1 For your top five products by production weight/volume, provide the following water intensity information associated with your activities in the chemical sector.',
        'This question provides data users with information on how organizations are monitoring the water intensity of their key products and the underlying factors that determine their trend for this metric. It is acknowledged that water intensities will naturally vary according to facility-specific factors like final product obtained, cooling technology or processes used. Specifying a type of metric also helps data users to understand common practice in the industry.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q21_1_VALUE,
            'Product type',
            CHEMICAL_PRODUCTS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q21_2_VALUE,
            'Product name',
            500
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q21_3_VALUE,
            'Water intensity value (m3/denominator)',
            2
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q21_4_VALUE,
            'Numerator: water aspect',
            WATER_INTENSITY_METRIC_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q21_5_VALUE,
            'Denominator',
            WATER_INTENSITY_UNIT_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q21_6_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q21_7_VALUE,
            'Please explain',
            2500
          )
        ],
        true,

        undefined,
        CDP_WATER_SECURITY_KEYS.Q20_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q22',
    showIndex: false,
    items: [
      {
        field: [
          {
            ...createSelectField(
              CDP_WATER_SECURITY_KEYS.Q22_VALUE,
              '9.7 Do you calculate water intensity for your electricity generation activities?',
              YES_NO_WITH_PLAN_OPTIONS,
              inputType.HEADING
            ),
            tooltip:
              'This metric encourages organizations with electricity generation activities to monitor water intensity data and improve efficiency. Data users seek improved transparency around the calculation of such metrics to enable performance monitoring and high-level benchmarking. In addition to total water volumes, water intensity metrics provide a complementary indicator to help identify efficiencies and opportunities in water withdrawals or consumption. This aligns with public policy goals related to water at all levels, including such as the Sustainable Development Goal 6.4.1.',
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: 'Q23',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q23_VALUE,
        '9.7.1 Provide the following intensity information associated with your electricity generation activities.',
        'This question provides data users with information on how organizations are monitoring their water intensity and the underlying factors that determine their trend for this metric. CDP acknowledges that water intensities will vary according to power generation source and technologies used. Specifying a type of metric also helps data users to understand common practice in the industry.',
        [
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q23_1_VALUE,
            'Water intensity value (m3/denominator)',
            2
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q23_2_VALUE,
            'Numerator: water aspect',
            WATER_INTENSITY_METRIC_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q23_3_VALUE,
            'Denominator',
            ELECTRICITY_GENERATION_INTENSITY_UNIT_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q23_4_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q23_5_VALUE,
            'Please explain',
            2500
          )
        ],
        true,

        undefined,
        CDP_WATER_SECURITY_KEYS.Q22_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q24',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_WATER_SECURITY_KEYS.Q24_VALUE,
        '9.8 Provide water intensity information for each of the agricultural commodities significant to your organization that you produce.',
        'The focus of this question is to ensure that organizations are monitoring the water intensity of their key produced commodities and that they are aware of the underlying factors that determine trends in product water intensity. It is acknowledged that water intensities will naturally vary according to local context factors like climate, soil, agricultural practices, crop varieties, or water management factors. Additionally, it may clarify how this metric is calculated including what water aspects were accounted for, how such factors may affect the metrics, or what company boundaries were used. Specifying a type of metric allows data users to understand common practice in the industry.',
        'Agricultural commodity',
        [],
        [
          // createRowMultiSelectField(
          //   CDP_WATER_SECURITY_KEYS.Q24_1_VALUE,
          //   'Agricultural commodity',
          //   COMMODITY_OPTIONS
          // ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q24_2_VALUE,
            'Water intensity information for this produced commodity is collected/calculated',
            WATER_INTENSITY_CALCULATION_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q24_3_VALUE,
            'Water intensity value (m3/denominator)',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q24_2_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q24_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q24_4_VALUE,
            'Numerator: water aspect',
            WATER_INTENSITY_METRIC_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q24_2_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q24_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q24_5_VALUE,
            'Denominator',
            WEIGHT_VOLUME_UNIT_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q24_2_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q24_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q24_6_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q24_2_VALUE,
              condition: conditionType.NOT,
              values: ['Yes']
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q24_2_VALUE,
              condition: conditionType.EQUALS,
              values: ['Yes'],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q24_7_VALUE,
            'Please explain',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q25',
    showIndex: false,
    items: [
      createTableWithFixedRowsQuestion(
        CDP_WATER_SECURITY_KEYS.Q25_VALUE,
        '9.9 Provide water intensity information for each of the agricultural commodities significant to your organization that you source.',
        'The focus of this question is to ensure that organizations are monitoring the water intensity of their key sourced commodities and that they are aware of the underlying factors that determine their trend for this metric. It is acknowledged that water intensities will naturally vary according to local context factors like climate, soil, agricultural practices, crop varieties or water management factors. Additionally, it may clarify how this metric is calculated including what water aspects were accounted for, how such factors may affect the metrics, or what organization boundaries were used. Specifying a type of metric allows data users to understand common practice in the industry.',
        'Agricultural commodity',
        [],
        [
          // createRowMultiSelectField(
          //   CDP_WATER_SECURITY_KEYS.Q25_1_VALUE,
          //   'Agricultural commodity',
          //   COMMODITY_OPTIONS
          // ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q25_2_VALUE,
            'Water intensity information for this produced commodity is collected/calculated',
            WATER_INTENSITY_CALCULATION_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q25_3_VALUE,
            'Water intensity value (m3/denominator)',
            2
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q25_4_VALUE,
            'Numerator: water aspect',
            WATER_INTENSITY_METRIC_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q25_5_VALUE,
            'Denominator',
            WEIGHT_VOLUME_UNIT_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q25_6_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q25_7_VALUE,
            'Please explain',
            2500
          )
        ]
      )
    ]
  },
  {
    key: 'Q26',
    showIndex: false,
    items: [
      {
        field: [
          {
            ...createSelectField(
              CDP_WATER_SECURITY_KEYS.Q26_VALUE,
              '9.10 Do you calculate water intensity information for your metals and mining activities?',
              YES_NO_WITH_PLAN_OPTIONS,
              inputType.HEADING
            ),
            tooltip:
              'This metric encourages organizations with activities in the metals & mining and coal sectors to monitor water intensity data and improve efficiency. Data users seek improved transparency around the calculation of such metrics to enable performance monitoring and high-level benchmarking. In addition to total water volumes, water intensity metrics provide a complementary indicator to help identify efficiencies and opportunities for the reduction of water withdrawals and consumption. This aligns with public policy goals related to water at all levels, such as the Sustainable Development Goal 6.4.1.',
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: 'Q27',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q27_VALUE,
        '9.10.1 For your top 5 products by revenue, provide the following intensity information associated with',
        'Various methods exist for calculating water intensity in the metals & mining and coal sectors, and it is acknowledged that water intensities will naturally vary according to local context factors like geology, landscape, hydrology, the mining methods used, or ore grades. Specifying a type of metric allows data users to understand common practice in the industry. This question provides them with information on how organizations determine a water intensity metric and are aware of the underlying factors that affects their trend. • Note that the question does not ask for an organization to provide water intensity data. CDP is taking a staged approach to this disclosure.',
        [
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q27_1_VALUE,
            'Product name',
            100
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q27_2_VALUE,
            'Numerator: water aspect',
            WATER_INTENSITY_METRIC_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q27_3_VALUE,
            'Denominator',
            METALS_MINING_INTENSITY_UNIT_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q27_4_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q27_5_VALUE,
            'Please explain',
            2000
          )
        ],
        true,

        undefined,
        CDP_WATER_SECURITY_KEYS.Q26_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q28',
    showIndex: false,
    items: [
      {
        field: [
          {
            ...createSelectField(
              CDP_WATER_SECURITY_KEYS.Q28_VALUE,
              '9.11 Do you calculate water intensity for your activities associated with the oil & gas sector?',
              YES_NO_WITH_PLAN_OPTIONS,
              inputType.HEADING
            ),
            tooltip:
              'This metric encourages organizations to monitor water intensity data and improve efficiency. In addition to total water volumes, water intensity metrics provide a complementary indicator to help identify efficiencies and reduction opportunities in water withdrawals or consumption. Data users also seek improved transparency around the calculation of such metrics to enable performance monitoring and high-level benchmarking. This aligns with public policy goals at all levels, including Sustainable Development Goal 6.4.1. Select one of the following options: • Yes • No, but we intend to do so within the next two years • No, and we have no plans to do so in the next two years',
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: 'Q29',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q29_VALUE,
        '9.11.1 Provide water intensity information associated with your activities in the oil & gas sector.',
        'The focus of this question is to determine which metric organizations are using to monitor their water intensity, and that they are aware of the underlying factors that determine their trend in this metric. Specifying a type of metric also allows data users to understand common practice in the industry. Various methods exist for calculating water intensity for the oil & gas sector. It is acknowledged that water intensities will naturally vary according to local context factors like geology, hydrology, or technology used.',
        [
          createRowMultiSelectField(
            CDP_WATER_SECURITY_KEYS.Q29_1_VALUE,
            'Business division',
            OIL_GAS_BUSINESS_DIVISION_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q29_2_VALUE,
            'Water intensity value (m3/denominator)',
            2
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q29_3_VALUE,
            'Numerator: water aspect',
            WATER_INTENSITY_METRIC_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q29_4_VALUE,
            'Denominator',
            OIL_GAS_INTENSITY_UNIT_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q29_5_VALUE,
            'Comparison with previous reporting year',
            CHANGE_FROM_LAST_REPORTING_YEAR_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q29_6_VALUE,
            'Please explain',
            2500
          )
        ],
        true,

        undefined,
        CDP_WATER_SECURITY_KEYS.Q28_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q30',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q30_VALUE,
        '9.12 Provide any available water intensity values for your organization’s products or services.',
        'Methodologies for calculating and reporting water intensity are currently becoming more standardized, particularly with the development of ISO 14046. CDP supply chain members are increasingly interested in the water use of their purchased products (goods or services). In particular, they are interested in the water intensity of the goods and services they purchase that are produced in facilities exposed to water risk (where that risk is related to access to water or physical scarcity).',
        [
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q30_1_VALUE,
            'Product name',
            500
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q30_2_VALUE,
            'Water intensity value',
            4
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q30_3_VALUE,
            'Numerator: Water aspect',
            WATER_ASPECT_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q30_4_VALUE,
            'Denominator',
            100
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q30_5_VALUE,
            'Comment',
            1000
          )
        ],
        true
      )
    ]
  },
  {
    key: 'Q31',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q31_VALUE,
        '9.13 Do any of your products contain substances classified as hazardous by a regulatory authority?',
        'Tracing and eliminating the use of hazardous substances in all sectors is pivotal in safeguarding the quality of water bodies and by extension the effects on humans and ecosystems. Keeping track of the hazardous substances present in their products allows companies to work systematically to phase out these substances.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q31_1_VALUE,
            'Products contain hazardous substances',
            YES_NO_UNKNOWN_ONLY_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q31_2_VALUE,
            'Comment',
            1000
          )
        ],
        true
      )
    ]
  },
  {
    key: 'Q32',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q32_VALUE,
        '9.13.1 What percentage of your company’s revenue is associated with products containing substances classified as hazardous by a regulatory authority?',
        'This question assesses whether your company monitors hazardous substances in your products, with the aim to improve the protection of human health and the environment from the risks posed by hazardous substances.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q32_1_VALUE,
            'Regulatory classification of hazardous substances',
            HAZARDOUS_SUBSTANCE_REGULATORY_LISTS_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q32_2_VALUE,
            '% of revenue associated with products containing substances in this list',
            REVENUE_FROM_LOW_WATER_IMPACT_PRODUCTS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q32_3_VALUE,
            'Please explain',
            1500
          )
        ],
        true,

        CDP_WATER_SECURITY_KEYS.Q31_VALUE,
        CDP_WATER_SECURITY_KEYS.Q31_1_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q33',
    showIndex: false,
    tod: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q33_VALUE,
        '9.14 Do you classify any of your current products and/or services as low water impact?',
        'Reducing the water impact of products, in the production or use phase of the value chain, will hasten the transition to a water-secure future. This question informs investors and other data users on the action that companies are taking towards this. There is no common definition of what constitutes a low water impact product and/or service, so companies are asked to explain the criteria and threshold used for classifying products and/or services as low water impact.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q33_1_VALUE,
            'Products and/or services classified as low water impact',
            YES_NO_WITH_PLAN_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q33_2_VALUE,
            'Definition used to classify low water impact',
            5000
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q33_3_VALUE,
            'Primary reason for not classifying any of your current products and/or services as low water impact',
            REASON_FOR_NO_TARGET_OPTIONS,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q33_1_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: [
                'No, but we intend to do so within the next two years',
                'No, and we have no plans to do so in the next two years'
              ]
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q33_1_VALUE,
              condition: conditionType.INCLUDES,
              values: [
                'No, but we intend to do so within the next two years',
                'No, and we have no plans to do so in the next two years'
              ],
              required: true
            }
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q33_4_VALUE,
            'Please explain',
            1000
          )
        ]
      )
    ]
  },
  {
    key: 'Q34',
    showIndex: false,
    items: [
      {
        field: [
          {
            ...createSelectField(
              CDP_WATER_SECURITY_KEYS.Q34_VALUE,
              '9.15 Do you have any water-related targets?',
              YES_NO_WITH_PLAN_OPTIONS,
              inputType.HEADING
            ),
            tooltip:
              'Target setting plays a vital role in water management and assists the successful execution of corporate strategies. Setting and making progress against targets helps decouple growth from dependence on water. CDP data users wish to know about your organization’s tracked, timebound, quantitative targets for achieving its water policy and commitments, improving water management, and responding to current and future water risks.',
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: 'Q35',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q35_VALUE,
        '9.15.1 Indicate whether you have targets relating to water pollution, water withdrawals, WASH, or other water-related categories.',
        'It is good practice for companies to set targets to reduce water withdrawals, reduce water pollution, and improve water, sanitation, and hygiene (WASH) services where these water aspects are relevant to the impact of their business activities on water security.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q35_1_VALUE,
            'Category of target',
            WATER_TARGET_CATEGORY_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q35_2_VALUE,
            'Target set in this category',
            YES_NO_WITH_PLAN_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q35_3_VALUE,
            'Please explain',
            1000,
            undefined,
            undefined,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q35_2_VALUE,
              condition: conditionType.NOT_INCLUDES,
              values: [
                'No, but we intend to do so within the next two years',
                'No, and we have no plans to do so in the next two years'
              ]
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q35_2_VALUE,
              condition: conditionType.INCLUDES,
              values: [
                'No, but we intend to do so within the next two years',
                'No, and we have no plans to do so in the next two years'
              ],
              required: true
            }
          )
        ],
        false,

        undefined,
        CDP_WATER_SECURITY_KEYS.Q34_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q36',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q36_VALUE,
        '9.15.2 Provide details of your water-related targets and the progress made.',
        'Data users wish to understand whether your water-related targets are relevant to the dependencies, impacts, risks, and opportunities associated with your activities, and the progress you are making towards these targets.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q36_1_VALUE,
            'Target reference number',
            TARGET_50_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q36_2_VALUE,
            'Target coverage',
            TARGET_LEVEL_OPTIONS
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q36_3_VALUE,
            'Category of target & Quantitative metric',
            WATER_TARGET_TYPE_OPTIONS
          ),
          createRowDatePickerField(
            CDP_WATER_SECURITY_KEYS.Q36_4_VALUE,
            'Date target was set'
          ),
          createRowDatePickerField(
            CDP_WATER_SECURITY_KEYS.Q36_5_VALUE,
            'End date of base year'
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q36_6_VALUE,
            'Base year figure',
            2
          ),
          createRowDatePickerField(
            CDP_WATER_SECURITY_KEYS.Q36_7_VALUE,
            'End date of target year'
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q36_8_VALUE,
            'Target year figure',
            2
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q36_9_VALUE,
            'Reporting year figure',
            2
          ),
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q36_10_VALUE,
            'Target status in reporting year',
            TARGET_STATUS_IN_REPORTING_YEAR_OPTIONS
          ),
          createRowNumberField(
            CDP_WATER_SECURITY_KEYS.Q36_11_VALUE,
            '% of target achieved relative to base year',
            2,
            true,
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q36_10_VALUE,
              condition: conditionType.NOT,
              values: [
                'New',
                'Underway',
                'Achieved',
                'Expired',
                'Revised',
                'Replaced',
                'Retired'
              ]
            },
            {
              fieldName: CDP_WATER_SECURITY_KEYS.Q36_10_VALUE,
              condition: conditionType.EQUALS,
              values: [
                'New',
                'Underway',
                'Achieved',
                'Expired',
                'Revised',
                'Replaced',
                'Retired'
              ],
              required: true
            }
          ),
          createRowMultiSelectField(
            CDP_WATER_SECURITY_KEYS.Q36_12_VALUE,
            'Global environmental treaties/initiatives/frameworks aligned with or supported by this target',
            WATER_TARGET_ALIGNMENT_FRAMEWORKS_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q36_13_VALUE,
            'Explain target coverage and identify any exclusions',
            1000
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q36_14_VALUE,
            'Plan for achieving target, and progress made to the end of the reporting year',
            1000
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q36_15_VALUE,
            'Actions which contributed most to achieving or maintaining this target',
            1000
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q36_16_VALUE,
            'Further details of target',
            1500
          )
        ],
        true,

        undefined,
        CDP_WATER_SECURITY_KEYS.Q34_VALUE,
        ['Yes']
      )
    ]
  },
  {
    key: 'Q37',
    showIndex: false,
    items: [
      createTableQuestion(
        CDP_WATER_SECURITY_KEYS.Q37_VALUE,
        '9.15.3 Why do you not have water-related target(s) and what are your plans to develop these in the future?',
        'Investors need an explanation as to why you do not have water-related targets in place, especially if your organization has a dependency on water or substantive water risks.',
        [
          createRowSelectField(
            CDP_WATER_SECURITY_KEYS.Q37_1_VALUE,
            'Primary reason',
            REASON_FOR_NO_WATER_TARGET_OPTIONS
          ),
          createRowWysiwygField(
            CDP_WATER_SECURITY_KEYS.Q37_2_VALUE,
            'Please explain',
            1500
          )
        ],
        false,
        undefined,
        CDP_WATER_SECURITY_KEYS.Q34_VALUE,
        ['Yes']
      )
    ]
  }
];
